import { usePostOfficeBottomSheetState } from '@apps/postOffice/PostOffice.bottomSheet';
import { useTranslation } from '@shared/core';
import { useEffect } from 'react';

interface ControllerProps {
  onVisible?: () => void;
}

export const useDesignECardViewController = (props: ControllerProps) => {
  const { t } = useTranslation('postOffice');
  const tBottomSheet = t('bottomSheet');
  const tDesignECard = tBottomSheet.designEcard;
  const { parentViewState } = usePostOfficeBottomSheetState();
  const handleButtonClick = parentViewState.openECardEditor;
  const disableEditEmail = parentViewState.disableEditEmail;

  useEffect(() => {
    props.onVisible?.();
  }, [props, props.onVisible]);

  return { tDesignECard, handleButtonClick, disableEditEmail };
};
